export {GaussianNB} from './GaussianNB';
export {MultinomialNB} from './MultinomialNB';
